import React, { useState } from "react";
import "../assets/styles/CogniStar.css";
import ComprehensiveIT from "../Components/ComprehensiveIT";
import Footer from "../Components/Footer";

function CogniStar() {
  const [name, setName] = useState("");
  const [age, setAge] = useState("");
  const [occasion, setOccasion] = useState("");
  const [star, setStar] = useState("");
  const [details, setDetails] = useState("");
  const [output, setOutput] = useState("");

  const generateGreeting = () => {
    if (!name) return alert("Please enter the recipient's name");

    const msg = `
🎉 Personalized AI Greeting
Here is your customized message:

Hi ${name}! You are turning ${age || "??"} 🎂
This greeting is specially crafted for your ${occasion || "special moment"}.

From: ${star || "Your Favorite Star"}

Personal Touch: ${details || "No extra details added"}

Enjoy your personalized AI greeting! 🎈
    `;

    setOutput(msg);
  };

  return (
    <>
      <div className="cs-page-container">

        {/* ======================== INTRO ======================== */}
        <section className="cs-intro-section">
          <h1>🌟CogniStar –Turn every message into a memory </h1>
          <p>
              CogniStar transforms ordinary wishes into cinematic, emotionally rich AI greetings —
              crafted in text, voice, or simulated video. Perfect for birthdays, anniversaries,
              achievements, festivals, and every meaningful moment.
              <br /><br />
                           <b>✨ Because a message shouldn’t just be sent — it should be felt.</b>


          </p>
        </section>

        {/* ======================== DETAILS SECTION ======================== */}
        <section className="cs-info">
          <h2>🌟 What is CogniStar?</h2>
          <p>
            CogniStar generates AI-powered personalized greetings that feel warm,
            emotional, and star-style — making every wish feel cinematic.

          </p>

          <h2>✨ Why CogniStar?</h2>
          <p>
            Unlike regular greeting cards or messages, CogniStar creates
            celebrity-style, emotionally rich greetings that truly stand out.
          </p>

          <h2>🎬 How CogniStar Works</h2>
          <ul>
            <li>Enter name, age & occasion</li>
            <li>Select a star </li>
            <li>Add personal details</li>
            <li>Get AI text instantly</li>
            <li>Download or share</li>
          </ul>

          <h2>🎯 Who is CogniStar For?</h2>
          <ul>
            <li>Birthdays, Anniversaries, Graduations & Milestones</li>
            <li>Parents, Grandparents, Best Friends & Loved Ones</li>
            <li>Professional greetings for colleagues & managers</li>
            <li>Special days like Valentine's, Get Well Soon & Festivals</li>
          </ul>

          <h2>🤖 Behind the Magic</h2>
          <ul>
            <li><b>Emotional Context Analysis</b> — understands personality.</li>
            <li><b>Star-style scripting</b> — actor-like tone & feel.</li>
            <li><b>AI Voice/Video </b> — realistic actor simulation.</li>
          </ul>
        </section>

        {/* ======================== FORM + OUTPUT ======================== */}
        <section className="cs-form-output-wrapper">

          {/* FORM */}
          <div className="cs-form">
            <h2>🎁 Create Your Personalized Greeting</h2>

            <input
              placeholder="Recipient Name"
              value={name}
              onChange={(e) => setName(e.target.value)}
            />

            <input
              placeholder="Age"
              value={age}
              onChange={(e) => setAge(e.target.value)}
            />

            <input
              placeholder="Occasion (Birthday, Anniversary...)"
              value={occasion}
              onChange={(e) => setOccasion(e.target.value)}
            />

            <input
              placeholder="Desired Actor "
              value={star}
              onChange={(e) => setStar(e.target.value)}
            />

            <textarea
              placeholder="About You"
              value={details}
              onChange={(e) => setDetails(e.target.value)}
            />

            <button onClick={generateGreeting}>Generate Greeting</button>
          </div>

          {/* OUTPUT */}
          <div className="cs-output-box">
            <h2>🎉 AI Generated Greeting</h2>
            <pre>{output || "Your AI greeting will appear here..."}</pre>
          </div>
        </section>

        {/* ======================== FAQ ======================== */}
        <section className="cs-faq">
          <h2>❓ FAQ</h2>

          <p><b>Is the video real?</b>
          No — it’s an AI simulation created ethically for entertainment.</p>

          <p><b>How long does it take?</b>
          Text: Instant • Voice/Video: 3–5 mins</p>

          <p><b>Can I regenerate?</b>
          Yes — unlimited regenerations.</p>

          <p><b>How to share?</b>
          Download and send via WhatsApp, Instagram, Email, etc.</p>
        </section>

      </div>

      {/* FOOTER + CONSULT FORM */}
      <ComprehensiveIT />
      <Footer />
    </>
  );
}

export default CogniStar;
